import { render, staticRenderFns } from "./ScrollableCategories.vue?vue&type=template&id=15dc7e58"
import script from "./ScrollableCategories.vue?vue&type=script&lang=js"
export * from "./ScrollableCategories.vue?vue&type=script&lang=js"
import style0 from "./ScrollableCategories.vue?vue&type=style&index=0&id=15dc7e58&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports